import React from 'react'

export const MapIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.33333 11.9982L5.596 11.6253C5.41093 11.5316 5.20689 11.4828 5 11.4828C4.79311 11.4828 4.58907 11.5316 4.404 11.6253L1.96467 12.8615C1.8629 12.913 1.74982 12.9373 1.63617 12.9321C1.52253 12.9268 1.41211 12.8921 1.31541 12.8314C1.21872 12.7707 1.13898 12.6859 1.08377 12.5851C1.02856 12.4843 0.999721 12.3708 1 12.2556V3.63383C1.00007 3.50841 1.03459 3.38548 1.0997 3.27882C1.16482 3.17216 1.25795 3.08597 1.36867 3.02991L4.404 1.49173C4.58907 1.39803 4.79311 1.34924 5 1.34924M5 1.34924C5.20689 1.34924 5.41093 1.39803 5.596 1.49173L8.404 2.91439C8.58907 3.0081 8.79311 3.05688 9 3.05688M5 1.34924V11.4821M9 3.05688C9.20689 3.05688 9.41093 3.0081 9.596 2.91439L12.0353 1.67818C12.137 1.62668 12.2501 1.60239 12.3637 1.60763C12.4773 1.61287 12.5876 1.64747 12.6843 1.70813C12.781 1.76878 12.8607 1.85349 12.916 1.95419C12.9712 2.05489 13.0002 2.16823 13 2.28345V7.26951M9 3.05688V7.26951M11 9.29609V13.3492M13 11.3227H9"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
